import { AppBar, Dialog, IconButton, Paper, Slide, Typography, withStyles } from '@material-ui/core';
import { } from '@material-ui/core/styles';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import MUIDataTable from 'mui-datatables';
import React from 'react';
import { withLoading } from '../../contexts/LoadingContext';
import RelatorioReembolsoService from '../../services/RelatorioReembolsoService';
import LinearProgressBlockScreen from '../share/LinearProgressBlockScreen';

const styles = theme => ({
  appBar: {
    position: 'relative',
  },
  toolbar: {
    display: 'flex',
    backgroundColor: '#5c6bc0',
    justifyContent: 'flex-start',
    alignItems: 'center',
    cursor: 'pointer',
    padding: theme.spacing.unit * 2,
  },
  flex: {
    flex: 1,
  },
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 15,
    paddingBottom: theme.spacing.unit * 15,
    margin: theme.spacing.unit * 2,
  },
  fontReport: {
    fontSize: 10
  },
  fontReportMoney: {
    fontSize: 10,
    width: '25px'
  }
});

function Transition (props) {
  return <Slide direction='left' {...props} />;
}
class FullScreenRelatorioReembolsoExport extends React.Component {
  relatorioReembolsoService = new RelatorioReembolsoService();
  state = {
    reembolsos: [],
    loading: true,
  }

  consultarRelatorioReembolso = async (filtro) => {
    const reembolsos = await this.relatorioReembolsoService.consultarRelatorioReembolsoExport(filtro);
    this.setState({ reembolsos: reembolsos, loading: false });
  }

  componentDidMount () {
    this.props.showLoading('Aguarde, essa consulta pode demorar um pouco..');
    this.consultarRelatorioReembolso(this.props.filtro);
    this.props.hideLoading();
  }

  render () {
    const { classes, open, handleClose } = this.props;
    const options = {
      selectableRows: false,
      print: false,
      download: true,
      filterType: 'dropdown',
      rowsPerPageOptions: [25, 50, 100, 500, 1000],
      rowsPerPage: 50,
      textLabels: {
        body: {
          noMatch: 'Desculpe, nenhum registro encontrado',
          toolTip: 'Ordenar',
        },
        pagination: {
          next: 'Próxima Página',
          previous: 'Página Anterior',
          rowsPerPage: 'Registros por Página:',
          displayRows: 'de',
        },
        toolbar: {
          search: 'Procurar',
          downloadCsv: 'Download CSV',
          print: 'Imprimir',
          viewColumns: 'Ver Colunas',
          filterTable: 'Filtrar',
        },
        filter: {
          all: 'Todos',
          title: 'FILTROS',
          reset: 'RESET',
        },
        viewColumns: {
          title: 'Mostrar Colunas',
          titleAria: 'Exibir/Ocultar Colunas',
        },
        selectedRows: {
          text: <Typography style={{ display: 'inline' }}>registro(s) selecionado(s)</Typography>,
          delete: 'Deletar',
          deleteAria: 'Deletar Linhas Selecionadas',
        },
      }
    };
    const columns = [
      {
        name: 'Cógigo',
        options: {
          filter: true,
          sort: true,
          setCellProps: () => {
            return {
              className: classes.fontReport
            };
          }
        },
      },
      {
        name: 'Beneficiário',
        options: {
          filter: true,
          sort: true,
          setCellProps: () => {
            return {
              className: classes.fontReport
            };
          }
        },
      },
      {
        name: 'seqFolha',
        options: {
          display: 'excluded',
          filter: false,
          sort: false,
        }
      },
      {
        name: 'codRubrica',
        options: {
          display: 'excluded',
          filter: false,
          sort: false,
        }
      },
      {
        name: 'Rubrica',
        options: {
          filter: true,
          sort: true,
          setCellProps: () => {
            return {
              className: classes.fontReport
            };
          }
        },
      },
      {
        name: 'Valor Reembolso',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => {
            const nf = new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });
            return nf.format(value);
          },
          setCellProps: () => {
            return {
              className: classes.fontReportMoney
            };
          }
        },
      },
    ];
    return (
      <div>
        <Dialog
          fullScreen
          open={open}
          onClose={handleClose}
          scroll='paper'
          TransitionComponent={Transition}
        >
          <AppBar className={classes.appBar}>
            <Paper square elevation={0} className={classes.toolbar} onClick={handleClose} color='inherit'>
              <IconButton color='inherit' onClick={handleClose} aria-label='Close'>
                <ChevronLeft />
              </IconButton>
              <Typography variant='title' color='inherit' className={classes.flex}>
                {'Relatório de Reembolsos - Data de Referência: ' + this.props.mesAno}
              </Typography>
            </Paper>
          </AppBar>
          {this.state.loading ? <LinearProgressBlockScreen />
            : <MUIDataTable
              data={this.state.reembolsos}
              columns={columns}
              options={options}
            />
          }
        </Dialog>
      </div>
    );
  }
}

export default withLoading(withStyles(styles)(FullScreenRelatorioReembolsoExport));
